<app-section-banner [title]="'services_section.title_Banner' | translate"
	[backgroundImage]="'assets/img/banner-services.png'">
</app-section-banner>

<!-- Services Section -->
<section class="relative w-full bg-[#5173EF] h-auto lg:h-32 xl:h-48">
	<div class="max-w-screen-xl mx-auto  flex flex-col lg:flex-row justify-between items-center h-full">

		<!-- Services Content -->
		<div class="w-full  xl:w-1/2  flex flex-col justify-center items-start p-4 text-[#F2F4FE] order-first h-full">
			<h2 class="text-[#F2F4FE] text-center sm:text-left  text-sm sm:text-base md:text-lg font-semibold mb-2">
				{{ 'services_section.title' | translate }}
			</h2>
			<nav class="flex flex-wrap justify-start items-center gap-2 text-[#F2F4FE] 2xl:flex-nowrap">
				<!-- "ALL" Link -->
				<button type="button" (click)="selectService(0, $event)"
					class="relative inline-block pb-1 text-[10px] sm:text-[8px] md:text-[9px] lg:text-[9px] xl:text-[10px] 2xl:text-[11px] font-george-town transition-colors duration-300 hover:text-white whitespace-nowrap"
					[ngClass]="{
                        'bg-white/20 rounded px-2 py-[2px] text-white after:content-[] after:absolute after:bottom-0 after:left-0 after:w-full after:h-[2px] after:bg-[#F2F4FE] after:scale-100 after:origin-left after:transition-transform after:duration-300': selectedService === 0
                    }" [attr.aria-label]="'services_section.aria_all' | translate">
					{{ 'services_section.all' | translate }}
				</button>


				<!-- Service Links -->
				<ng-container *ngFor="let service of services; let i = index">
					<button type="button" (click)="selectService(i + 1, $event)"
						[attr.aria-label]="'services_section.aria_service' | translate:{service: service.name}"
						class="relative inline-block pb-1 text-[10px] sm:text-[8px] md:text-[9px] lg:text-[9px] xl:text-[10px] 2xl:text-[11px] font-george-town transition-colors duration-300 hover:text-white whitespace-nowrap"
						[ngClass]="{
                            'bg-white/20 rounded px-2 py-[2px] text-white after:content-[] after:absolute after:bottom-0 after:left-0 after:w-full after:h-[2px] after:bg-[#F2F4FE] after:scale-100 after:origin-left after:transition-transform after:duration-300': selectedService === i + 1
                        }">
						{{ service.name! | translate }}
					</button>
				</ng-container>
			</nav>
		</div>

		<!-- Selected Service Image (Hidden on small screens) -->
		<div *ngIf="selectedService > 0"
			class="relative w-full lg:w-1/2 flex justify-center items-center hidden lg:flex">
			<div class="relative max-w-custom w-full h-[41.5rem] mt-[29.5rem] overflow-hidden group">
				<picture>
					<!-- Fuente para WebP -->
					<source [srcset]="services[selectedService - 1].imageWebP" type="image/webp">
					<!-- Imagen de respaldo (por si WebP no es compatible) -->
					<img [src]="services[selectedService - 1].image"
						[attr.aria-label]="'Service image: ' + services[selectedService - 1].name"
						alt="{{ services[selectedService - 1].name }}"
						class="absolute inset-0 w-full h-full object-cover transition-transform duration-300 lg:hidden xl:block group-hover:scale-105 z-10"
						loading="lazy">
				</picture>
				<div
					class="absolute inset-0 bg-gradient-to-t from white to transparent opacity-60 group-hover:opacity-75 transition-opacity duration-300 z-20">
				</div>
			</div>
		</div>
		<!-- Right column with 2 larger images (Hidden on small screens) -->
		<div *ngIf="selectedService === 0"
			class=" flex flex-col gap-1 lg:w-3/5 xl:w-2/5 2xl:w-3/5 lg:mt-[54.5rem] xl:mt-[52.9rem] 2xl:mt-[78.5rem] lg:-translate-x-8 xl:-translate-x-24 2xl:ml-36 hidden lg:flex lg:gap-2">
			<ng-container *ngFor="let service of services; let i = index">
				<div *ngIf="i % 2 !== 0" class="relative group">
					<div class="relative flex w-full h-full overflow-hidden">
						<picture class="block w-full">
							<!-- Fuente para WebP -->
							<source [srcset]="service.imageWebP" type="image/webp" />
							<!-- Imagen de respaldo (por si WebP no es compatible) -->
							<img [src]="service.image" [alt]="'services.' + service.name + '.name' | translate"
								[attr.aria-label]="'services_section.aria_image_label' | translate:{service: ('services.' + service.name + '.name' | translate)}"
								width="1280" height="720" loading="lazy" class="w-full h-auto object-cover shadow-lg transition-transform duration-300 group-hover:scale-105
                                    lg:w-[41vw] lg:max-w-[540px] lg:max-h-[1200px] 
                                    xl:w-[41vw] xl:max-w-[620px] xl:max-h-[800px] 
                                    2xl:w-[35vw] 2xl:max-w-[530px] 2xl:max-h-[1200px]" [ngClass]="{
                                    'lg:h-[40rem] xl:h-[42.5rem] 2xl:h-[52rem]': service.id === 2,
    								'lg:h-[22rem] xl:h-[22rem] 2xl:h-[38rem]': service.id === 4
                                    }" />
						</picture>


						<!-- White overlay with 70% opacity -->
						<div
							class="absolute inset-0 bg-white opacity-70 group-hover:opacity-70 transition-opacity duration-300">
						</div>
					</div>
					<div *ngIf="selectedService !== i + 1"
						class="absolute inset-0 flex flex-col justify-center items-center text-center p-4">
						<p class="text-normal tracking-wide text-[#020042] font-georgetown mb-4">{{ service.name |
							translate }}</p>
						<button type="button" (click)="selectService(i + 1, $event); goToService(i + 1)"
							[attr.aria-label]="'services_section.aria_explore_label' | translate:{service: service.name}"
							class="px-4 py-2 bg-transparent text-[#5173EF] text-sm italic rounded transition hover:bg-transparent hover:text-[#3751A6]">
							{{ 'services_section.explore_more' | translate }}
						</button>

					</div>
				</div>
			</ng-container>
		</div>
	</div>
</section>

<!-- Selected Service Content -->
<section #descriptionSection class="relative w-full bg-white">
	<div class="max-w-screen-xl mx-auto flex flex-col lg:flex-row items-start">
		<!-- Selected Service Description -->
		<div *ngIf="selectedService > 0"
			class="w-full xl:w-1/2 flex flex-col p-8 pl-8 bg-transparent text-justify relative group min-h-[300px] mt-6">
			<h3 class="text-lg font-semibold mb-3">{{ services[selectedService - 1].name! | translate }}
			</h3>
			<hr class="w-8 border-t-2 border-[#020042] mt-3 mb-3">

			<!-- Service description -->
			<p class="text-sm font-light leading-loose mb-4 xl:w-[34rem] max-w-full"
				[innerHTML]="services[selectedService - 1].description | translate">
			</p>

			<!-- Client and Tools section -->
			<div class="text-[#020042] flex flex-wrap text-xs font-light mt-4">
				<!-- Client -->
				<p class="mr-4 flex items-center mb-6">
					<strong class="font-bold text-sm">{{ 'services_section.clients_label' | translate }}</strong>
					<span class="font-light text-xs ml-1">{{ services[selectedService - 1].client | translate }}</span>
				</p>
				<!-- Tools -->
				<p class="flex items-center mb-6">
					<strong class="font-bold text-sm">{{ 'services_section.tools_label' | translate }}</strong>
					<span class="font-light text-xs ml-1">{{ services[selectedService - 1].tools | translate }}</span>
				</p>
			</div>

			<!-- "!Hablemos!" button -->
			<a href="/contact"
				class="flex items-center justify-center h-9 w-44 bg-[#5173EF] text-[#F2F4FE] text-xs font-light tracking-wide hover:bg-[#020042] rounded transition-all duration-300 self-start mt-4"
				[attr.aria-label]="'services_section.talk_aria' | translate">
				{{ 'services_section.talk_button' | translate }}
			</a>
		</div>
	</div>
</section>

<!-- Gallery of Services (only visible if ALL is selected) -->
<!-- Hidden on small screens -->
<div *ngIf="selectedService === 0"
	class="max-w-screen-xl mx-auto mb-8 px-4 grid gap-2 mt-4 lg:grid-cols-2 hidden lg:grid ">
	<!-- Left column with 3 smaller images -->
	<div class="flex flex-col gap-2">
		<ng-container *ngFor="let service of services; let i = index">
			<div *ngIf="i % 2 === 0" class="relative group w-full">
				<div class="relative w-full h-full overflow-hidden">
					<!-- Using <picture> for WebP support -->
					<picture>
						<source [srcset]="service.imageWebP" type="image/webp" />
						<img [src]="service.image" [alt]="'services.' + service.name + '.name' | translate"
							[attr.aria-label]="'services_section.aria_image_label' | translate:{service: ('services.' + service.name + '.name' | translate)}"
							width="1280" height="720" loading="lazy"
							class="w-full h-auto object-cover shadow-lg transition-transform duration-300 group-hover:scale-105"
							[ngClass]="{
             'lg:h-[14.7rem] xl:h-[13rem] 2xl:h-[18rem]':  service.id === 1,
             'lg:h-[15.8rem] xl:h-[16rem] 2xl:h-[20.6rem]':service.id === 3,
             'lg:h-[22rem] xl:h-[22rem] 2xl:h-[38rem]':service.id === 5,
             
         }">
					</picture>
					<!-- White overlay with 70% opacity -->
					<div
						class="absolute inset-0 bg-white opacity-70 group-hover:opacity-70 transition-opacity duration-300">
					</div>
				</div>
				<div *ngIf="selectedService !== i + 1"
					class="absolute inset-0 flex flex-col justify-center items-center text-center p-4">
					<p class="text-normal tracking-wide text-[#020042] font-georgetown mb-4">{{ service.name | translate
						}}</p>
					<button type="button" (click)="selectService(i + 1, $event); goToService(i + 1)"
						[attr.aria-label]="'services_section.aria_explore_label' | translate:{service: service.name}"
						class="px-4 py-2 bg-transparent text-[#5173EF] text-sm italic rounded transition hover:bg-transparent hover:text-[#3751A6]">
						{{ 'services_section.explore_more' | translate }}
					</button>

				</div>
			</div>
		</ng-container>
	</div>
</div>

<!-- Gallery of Services (only visible if ALL is selected) -->
<!-- Visible on small screens -->
<div *ngIf="selectedService === 0" class="w-full mx-auto mt-4 px-4 grid grid-cols-1 gap-4 mb-8 lg:hidden">
	<div class="flex flex-col gap-2">
		<ng-container *ngFor="let service of services; let i = index">
			<div class="relative group">
				<div class="relative w-full h-full overflow-hidden">
					<!-- Using <picture> for WebP support -->
					<picture>
						<source [srcset]="service.imageWebP" type="image/webp">
						<img [src]="service.image"
							[attr.aria-label]="'services_section.aria_image_label' | translate:{service: service.name}"
							alt="{{ service.name }}"
							class="w-full h-auto object-cover shadow-lg transition-transform duration-300 group-hover:scale-105"
							loading="lazy">
					</picture>
					<!-- White overlay with 70% opacity -->
					<div
						class="absolute inset-0 bg-white opacity-70 group-hover:opacity-70 transition-opacity duration-300">
					</div>
				</div>
				<div class="absolute inset-0 flex flex-col justify-center items-center text-center p-4">
					<p class="text-normal tracking-wide text-[#020042] font-georgetown mb-4">{{ service.name ?
						(service.name | translate) : '' }}</p>
					<button type="button" (click)="selectService(i + 1, $event); goToService(i + 1)"
						[attr.aria-label]="'services_section.aria_explore_label' | translate:{service: service.name}"
						class="px-4 py-2 bg-transparent text-[#5173EF] text-sm italic rounded transition hover:bg-transparent hover:text-[#3751A6]">
						{{ 'services_section.explore_more' | translate }} </button>
				</div>
			</div>
		</ng-container>
	</div>
</div>

<!-- Gallery of Services (only visible if a specific service is selected) -->
<!-- Hidden on small screens -->
<div *ngIf="selectedService > 0" class="max-w-screen-xl mx-auto mt-8 px-4 grid gap-8 lg:grid-cols-2 hidden lg:grid"
	style="grid-template-columns: 52% 42%; grid-template-rows: repeat(2, auto);">
	<ng-container *ngFor="let service of services; let i = index">
		<div *ngIf="i !== selectedService - 1" class="relative group">
			<div class="relative object-contain w-full min-h-[15.5rem] sm:min-h-[20rem] lg:min-h-[20rem] overflow-hidden group"
				[ngClass]="{
             'h-[15.5rem] mb-8': i < 2,  
             'h-[20rem] mb-8': i >= 2  
           }">
				<!-- Using <picture> for WebP support -->
				<picture>
					<source [srcset]="service.imageWebP" type="image/webp">
					<img [src]="service.image"
						[attr.aria-label]="'services_section.aria_image_label' | translate:{service: service.name}"
						alt="{{ service.name | translate }}"
						class="w-full h-full object-cover rounded shadow-lg transition-transform duration-300 group-hover:scale-105 z-10"
						loading="lazy">
				</picture>
				<div
					class="absolute inset-0 bg-white opacity-70 group-hover:opacity-70 transition-opacity duration-300 z-20">
				</div>
			</div>
			<div class="absolute inset-0 flex justify-center items-center z-30">
				<div class="flex flex-col items-center justify-center text-center w-full p-4">
					<p class="text-normal tracking-wide text-[#020042] font-georgetown mb-4">
						{{ service.name | translate}}</p>
					<button type="button" (click)="selectService(i + 1, $event); goToService(i + 1)"
						[attr.aria-label]="'services_section.aria_explore_label' | translate:{service: service.name}"
						class="px-4 py-2 bg-transparent text-[#5173EF] text-sm italic rounded transition hover:bg-transparent hover:text-[#3751A6]">
						{{ 'services_section.explore_more' | translate }}
					</button>

				</div>
			</div>
		</div>
	</ng-container>
</div>

<!-- Vertical layout for selected service on small screens -->
<!-- Hidden on large screens -->
<div *ngIf="selectedService > 0" class="w-full mx-auto mt-8 px-4 grid gap-8 lg:hidden">
	<ng-container *ngFor="let service of services; let i = index">
		<div *ngIf="i !== selectedService - 1" class="relative group">
			<div class="relative w-full min-h-[15.5rem] sm:min-h-[20rem] overflow-hidden group">
				<!-- Using <picture> for WebP support -->
				<picture>
					<source [srcset]="service.imageWebP" type="image/webp">
					<img [src]="service.image"
						[attr.aria-label]="'services_section.aria_image_label' | translate:{service: service.name}"
						alt="{{ service.name }}"
						class="w-full h-full object-cover rounded shadow-lg transition-transform duration-300 group-hover:scale-105 z-10"
						loading="lazy">
				</picture>
				<div
					class="absolute inset-0 bg-white opacity-70 group-hover:opacity-70 transition-opacity duration-300 z-20">
				</div>
			</div>
			<div class="absolute inset-0 flex justify-center items-center z-30">
				<div class="flex flex-col items-center justify-center text-center w-full p-4">
					<p class="text-normal tracking-wide text-[#020042] font-georgetown mb-4">{{ service.name | translate
						}}</p>
					<button type="button" (click)="selectService(i + 1, $event); goToService(i + 1)"
						[attr.aria-label]="'services_section.aria_explore_label' | translate:{service: service.name}"
						class="px-4 py-2 bg-transparent text-[#5173EF] text-sm italic rounded transition hover:bg-transparent hover:text-[#3751A6]">
						{{ 'services_section.explore_more' | translate }}
					</button>
				</div>
			</div>
		</div>
	</ng-container>
</div>

<app-technologies></app-technologies>